import type {FormDataEntryProgressStep} from '../components/Container/Presenter/Progress/ProgressStepDrawer';

export const validateProgressStepForm = (data: FormDataEntryProgressStep) => {
  const errors: Partial<Record<keyof FormDataEntryProgressStep, string>> = {};

  if (!data.stepName.trim()) {
    errors.stepName = '選考予定は必須です';
  }

  // 備考の文字数制限 TODO: 決める
  // if (data.notes && data.notes.length > 500) {
  //   errors.notes = '備考は500文字以内で入力してください';
  // }

  if (data.startDate && data.endDate && data.startDate > data.endDate) {
    errors.startDate = '開始日は終了日より前の日付を選択してください';
    errors.endDate = '終了日は開始日より後の日付を選択してください';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
